export const strings = {
  title: 'Exams',
  subtitle: 'One exam per course, and the rules that compose its questions',
  create: 'New Exam',
  close: 'Close',
  save: 'Save',
  saved: 'Saved successfully',
  deleted: 'Deleted successfully',
  actionFailed: 'The operation could not be completed',
  deleteConfirm: 'Are you sure you want to delete this exam?',
  allCoursesHaveExam: 'Every course already has an exam',

  columns: {
    index: 'ID',
    course: 'Course',
    name: 'Exam Name',
  },

  row: {
    edit: 'Update',
    delete: 'Delete',
  },

  form: {
    editTitle: 'Update Exam',
    createTitle: 'New Exam',
    course: 'Course',
    nameAr: 'Arabic Name',
    nameEn: 'English Name',
    passLimit: 'Pass Mark',
    tries: 'Attempts',
    forceWatch: 'Require watching the content',
    hideAnswers: 'Hide answers',
    preventIfSucceeded: 'Prevent retaking after a pass',
    rewatch: 'Re-watch percentage on failure',
    required: 'This field is required',
  },

  rules: {
    title: 'Question Rules',
    hint: 'Each rule sets how many questions are taken from one topic at one difficulty',
    topic: 'Topic',
    level: 'Difficulty',
    count: 'Questions',
    available: 'Available',
    add: 'Add rule',
    remove: 'Remove',
    empty: 'No rules added yet',
    tooMany: 'More questions than are available',
  },
}
